import React, { useState } from 'react';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { sharedInputSx } from '../../Products/kitchenProductsConstants';

function mdyToDayjs(mdy) {
  const s = String(mdy ?? '').trim();
  if (!s) return null;
  const parsed = dayjs(s, 'MM/DD/YYYY', true);
  return parsed.isValid() ? parsed : null;
}

const datePickerSlotSxDark = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: '10px',
    fontFamily: 'Inter Regular, sans-serif',
    fontSize: 13,
    color: '#f4f4f5',
    bgcolor: 'rgba(0, 0, 0, 0.25)',
    '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.12)' },
    '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.22)' },
    '&.Mui-focused fieldset': { borderColor: '#f5b800', borderWidth: '1px' },
  },
  '& .MuiInputLabel-root': {
    fontFamily: 'Inter Regular, sans-serif',
    fontSize: 13,
    color: '#a1a1aa',
    '&.Mui-focused': { color: '#f5b800' },
  },
  '& .MuiIconButton-root': { color: '#a1a1aa' },
  '& .MuiIconButton-root:hover': { color: '#f5b800' },
};

export function OrderTrackingDatePicker({ deliveryDate, onDeliveryDateChange, tone = 'dark', sx = {} }) {
  const [open, setOpen] = useState(false);
  const value = mdyToDayjs(deliveryDate);
  const fieldSx =
    tone === 'light' ? { width: '100%', ...sharedInputSx, ...sx } : { ...datePickerSlotSxDark, ...sx };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className='otd-filters__datepicker-wrap'>
        <DatePicker
          label='Delivery date'
          value={value}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          onChange={(newValue) => {
            if (newValue?.isValid()) {
              onDeliveryDateChange(newValue.format('MM/DD/YYYY'));
            }
            setOpen(false);
          }}
          format='MMM D, YYYY'
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
              onClick: () => setOpen(true),
              onFocus: () => setOpen(true),
              sx: fieldSx,
            },
            openPickerButton: {
              'aria-label': 'Open calendar',
              onClick: () => setOpen(true),
            },
            popper: {
              sx: { zIndex: 1400 },
            },
            desktopPaper: {
              sx: {
                borderRadius: '14px',
                boxShadow: '0 12px 40px rgba(0,0,0,0.35)',
              },
            },
          }}
        />
      </div>
    </LocalizationProvider>
  );
}
